function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#483B3B",
  fillRule: "evenodd",
  d: "M50.787 29.392c-1.828 0-3.588.289-5.238.818 3.433-3.081 5.59-7.533 5.59-12.483 0-9.302-7.613-16.842-17.004-16.842-9.39 0-17.003 7.54-17.003 16.842 0 4.95 2.156 9.402 5.589 12.483a17.134 17.134 0 00-5.238-.818C8.093 29.392.48 36.932.48 46.234c0 9.303 7.613 16.843 17.003 16.843 8.208 0 15.056-5.76 16.652-13.422 1.596 7.662 8.444 13.422 16.652 13.422 9.39 0 17.003-7.54 17.003-16.843 0-9.301-7.612-16.842-17.003-16.842"
});

var SvgClub = function SvgClub(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "102px",
    height: "83px",
    viewBox: "0 1 68  62",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClub, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/club.a4a0b60e.svg";
export { ForwardRef as ReactComponent };